import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

function BarcodeCode93Svg({ style = {width: "300px", height: "180px"}, color = "primary", viewBox = "0 0 580 400" }) {
    return (
        <SvgIcon color={color} style={style} viewBox={viewBox}>
           <g transform="translate(0.000000,240.000000) scale(0.100000,-0.100000)"
                fill="#000000" stroke="none">
                <path d="M0 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M80 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M160 1600 l0 -800 80 0 80 0 0 800 0 800 -80 0 -80 0 0 -800z"/>
                <path d="M360 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M440 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M560 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M720 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M800 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M960 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M1080 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M1160 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M1360 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M1440 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M1560 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M1640 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M1800 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M1920 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M2040 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M2160 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M2280 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M2440 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M2520 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M2600 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M2680 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M2880 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M3040 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M3160 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M3240 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M3440 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M3520 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M3600 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M3760 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M3840 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M3960 1600 l0 -800 40 0 40 0 0 800 0 800 -40 0 -40 0 0 -800z"/>
                <path d="M4080 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M4160 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M4320 1600 l0 -800 40 0 40 0 0 800 0 800 -40 0 -40 0 0 -800z"/>
                <path d="M4440 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M4560 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M4680 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M4760 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M4920 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M5040 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M5120 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M5280 1600 l0 -800 40 0 40 0 0 800 0 800 -40 0 -40 0 0 -800z"/>
                <path d="M5400 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M5480 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M5560 1600 l0 -800 80 0 80 0 0 800 0 800 -80 0 -80 0 0 -800z"/>
                <path d="M5760 1600 c0 -793 0 -800 20 -800 20 0 20 7 20 800 0 793 0 800 -20
                800 -20 0 -20 -7 -20 -800z"/>
                <path d="M1508 703 c-10 -2 -18 -11 -18 -20 0 -11 7 -13 30 -8 l30 7 0 -86 c0
                -85 0 -86 -25 -86 -16 0 -25 -6 -25 -15 0 -12 14 -15 65 -15 51 0 65 3 65 15
                0 9 -9 15 -25 15 l-25 0 0 100 0 100 -27 -1 c-16 -1 -36 -3 -45 -6z"/>
                <path d="M1693 703 c-7 -2 -13 -10 -13 -18 0 -9 12 -11 45 -7 48 5 75 -8 75
                -37 0 -9 -27 -43 -60 -76 -33 -33 -60 -65 -60 -72 0 -9 21 -13 75 -13 60 0 75
                3 75 15 0 11 -12 15 -51 15 l-52 0 52 54 c64 68 68 106 14 135 -22 11 -77 14
                -100 4z"/>
                <path d="M1903 703 c-7 -2 -13 -11 -13 -19 0 -10 7 -13 25 -8 37 9 75 -3 75
                -25 0 -20 -18 -31 -51 -31 -10 0 -19 -7 -19 -15 0 -8 9 -15 21 -15 54 0 80
                -48 38 -71 -12 -6 -39 -9 -60 -6 -28 4 -39 1 -39 -8 0 -31 86 -34 124 -4 14
                11 26 29 26 40 0 30 -18 59 -38 59 -13 0 -12 3 6 16 47 33 12 95 -53 93 -16 0
                -36 -3 -42 -6z"/>
                <path d="M2130 635 c-65 -97 -65 -105 5 -105 52 0 55 -1 55 -25 0 -16 6 -25
                15 -25 9 0 15 9 15 25 0 16 6 25 15 25 8 0 15 7 15 15 0 8 -7 15 -15 15 -12 0
                -15 15 -15 75 0 68 -2 75 -20 75 -13 0 -36 -24 -70 -75z m57 -72 c-3 -2 -21
                -3 -41 -1 l-36 3 38 57 37 57 3 -56 c2 -30 1 -57 -1 -60z"/>
                <path d="M2290 651 l0 -60 34 6 c44 7 76 -11 76 -42 0 -32 -32 -49 -81 -42
                -28 4 -39 1 -39 -8 0 -16 22 -25 66 -25 42 0 84 37 84 75 0 36 -42 75 -80 75
                -25 0 -30 4 -30 25 0 23 4 25 45 25 33 0 45 4 45 15 0 12 -13 15 -60 15 l-60
                0 0 -59z"/>
                <path d="M2527 699 c-42 -25 -59 -103 -36 -168 19 -54 75 -68 123 -30 67 53
                -8 150 -85 109 -22 -12 -24 -3 -7 35 12 27 45 41 79 32 15 -4 19 -1 17 11 -4
                20 -64 28 -91 11z m77 -131 c14 -23 -3 -52 -33 -56 -42 -6 -67 38 -39 66 17
                17 58 11 72 -10z"/>
                <path d="M2680 695 c0 -12 13 -15 55 -15 l55 0 -20 -50 c-65 -164 -62 -152
                -43 -148 15 3 100 182 102 216 1 8 -20 12 -74 12 -60 0 -75 -3 -75 -15z"/>
                <path d="M2912 694 c-12 -8 -22 -26 -22 -39 0 -13 10 -31 22 -39 18 -13 19
                -16 6 -16 -38 0 -50 -68 -18 -100 43 -43 140 -15 140 41 0 30 -18 59 -38 59
                -13 0 -12 3 6 16 45 31 13 94 -48 94 -14 0 -36 -7 -48 -16z m72 -20 c23 -9 20
                -41 -4 -49 -29 -9 -60 4 -60 25 0 25 31 37 64 24z m20 -106 c15 -25 -4 -52
                -38 -56 -47 -6 -74 36 -44 66 18 18 69 11 82 -10z"/>
                <path d="M3106 689 c-68 -54 7 -150 85 -109 22 12 22 12 8 -29 -12 -33 -42
                -48 -80 -38 -15 4 -19 1 -17 -11 4 -19 37 -27 74 -18 51 13 79 104 54 172 -21
                55 -77 70 -124 33z m88 -31 c14 -23 -3 -52 -33 -56 -42 -6 -67 38 -39 66 17
                17 58 11 72 -10z"/>
                <path d="M3317 698 c-56 -44 -44 -198 17 -214 44 -11 76 4 92 41 26 62 12 155
                -26 175 -26 14 -63 12 -83 -2z m77 -40 c34 -48 10 -148 -34 -148 -27 0 -50 38
                -50 85 0 73 51 111 84 63z"/>
                <path d="M3534 673 c-9 -21 -29 -73 -45 -115 -24 -65 -26 -78 -13 -78 9 0 21
                14 27 30 11 28 15 30 62 30 47 0 51 -2 62 -30 6 -16 18 -30 27 -30 17 0 16 3
                -47 165 -29 74 -51 82 -73 28z m60 -80 c7 -21 4 -23 -29 -23 -26 0 -36 4 -32
                13 2 6 10 29 18 51 l14 38 11 -28 c6 -16 15 -39 18 -51z"/>
                <path d="M3710 594 l0 -116 71 4 c55 3 74 8 85 23 20 27 17 62 -5 84 -17 17
                -18 21 -5 32 21 17 17 56 -8 73 -14 10 -44 16 -80 16 l-58 0 0 -116z m114 80
                c9 -3 16 -14 16 -24 0 -21 -19 -30 -66 -30 -31 0 -34 3 -34 30 0 27 3 30 34
                30 19 0 41 -3 50 -6z m20 -106 c19 -30 -4 -53 -58 -56 l-46 -3 0 41 0 41 46
                -3 c31 -2 51 -9 58 -20z"/>
                <path d="M3933 703 c-7 -2 -13 -10 -13 -18 0 -9 12 -11 45 -7 48 5 75 -8 75
                -37 0 -9 -27 -43 -60 -76 -33 -33 -60 -65 -60 -72 0 -9 21 -13 75 -13 60 0 75
                3 75 15 0 11 -12 15 -51 15 l-52 0 52 54 c64 68 68 106 14 135 -22 11 -77 14
                -100 4z"/>
                <path d="M4130 595 c0 -94 3 -115 15 -115 11 0 15 19 17 92 l3 92 50 -92 c40
                -73 55 -92 73 -92 22 0 22 2 22 115 0 94 -3 115 -15 115 -11 0 -15 -19 -17
                -92 l-3 -92 -50 92 c-40 73 -55 92 -72 92 -23 0 -23 -2 -23 -115z"/>
                </g>

        </SvgIcon>
    );
}

export default BarcodeCode93Svg;
